export const FETCH_CUSTOMER_CONTACT_MEDIA = 'OVID/CUSTOMER/V3/FETCH_CUSTOMER_CONTACT_MEDIA'
export const FETCH_CUSTOMER_CONTACT_MEDIA_SUCCESS =
  'OVID/CUSTOMER/V3/FETCH_CUSTOMER_CONTACT_MEDIA_SUCCESS'
export const FETCH_CUSTOMER_CONTACT_MEDIA_ERROR =
  'OVID/CUSTOMER/V3/FETCH_CUSTOMER_CONTACT_MEDIA_ERROR'
